import React from 'react';
import styles from './ReportableStatus.module.scss';
import { SFRadioGroup, SFText } from 'sfui';

export type ReportableStatusValue = 'reportable' | 'not-reportable';

export interface ReportableStatusProps {
  status: ReportableStatusValue;
  onChange: (value: ReportableStatusValue) => void;
}

export const ReportableStatus = ({
  status,
  onChange
}: ReportableStatusProps): React.ReactElement<ReportableStatusProps> => {
  return (
    <div className={styles.reportableStatus}>
      <SFText type="component-title">Change Reportable Status</SFText>
      <div className={styles.statusContainer}>
        <SFRadioGroup
          options={[
            { label: 'Reportable to the state', value: 'reportable' },
            { label: 'Not reportable to the state', value: 'not-reportable' }
          ]}
          value={status}
          onChange={(_e, value) => onChange(value as ReportableStatusValue)}
        ></SFRadioGroup>
      </div>
    </div>
  );
};
